import type { Lucid } from '../../types/types';
import isBrowser from '../isBrowser';

const sendBeaconEvent = (event: Lucid.Beacon.Base) =>
  new Promise<boolean>(resolve => {
    if (isBrowser()) {
      const tryRecordEvent = (attempts: number) => {
        try {
          if (window && window.lucid && window.lucid?.beacon) {
            window.lucid.beacon.recordEvent(event);
            resolve(true);
          }
        } catch (error) {
          if (attempts > 0) {
            setTimeout(() => tryRecordEvent(attempts - 1), 250);
          } else {
            console.info(
              `[INFO]: Unable to fire beacon event: (%c${event.name}) \n%c${error}`,
              'color: green;',
              'color: red;',
            );
            resolve(false);
          }
        }
      };

      tryRecordEvent(5);
    }

    resolve(false);
  });

export default sendBeaconEvent;
